/**
 * Jeden event dataLayer pod piksele reklamowe (OpenAI Ads): w GTM jedna regula
 * na `ads_conversion` i jeden tag. Typ konwersji w slowniku OpenAI, event_id
 * ten sam co w Conversions API po stronie serwera (deduplikacja).
 */

// Typy leadow (config/tracking.php), ktorych serwer nie raportuje jako konwersji:
// rejestracja idzie osobno (registration_completed), service to reklamacje/ankiety.
const SKIPPED_LEAD_TYPES = ['registration', 'service'];

// eventy koszykowe OpenAI maja data.type=contents, reszta customer_action
const CONTENTS_TYPES = ['order_created', 'items_added', 'checkout_started'];

export const pushAdsConversion = (type, eventId, value = null) => {
    if (!eventId) {
        return;
    }

    const amount = Number(value);
    const data = { type: CONTENTS_TYPES.includes(type) ? 'contents' : 'customer_action' };

    if (amount > 0) {
        // OpenAI chce kwote w groszach
        data.amount = Math.round(amount * 100);
        data.currency = window.config?.currency?.code;
    }

    window.dataLayer = window.dataLayer || [];
    // GTM scala obiekty z kolejnych pushy - bez resetu kwota z zakupu
    // przeleciala by do leada (tak samo jak ecommerce: null)
    window.dataLayer.push({ conversion: null });
    window.dataLayer.push({
        event: 'ads_conversion',
        event_id: eventId,
        // conversion.data idzie 1:1 jako trzeci argument oaiq('measure', ...)
        conversion: { type, data },
    });
};

export const pushLeadConversion = (eventId, leadType) => {
    if (SKIPPED_LEAD_TYPES.includes(leadType)) {
        return;
    }

    pushAdsConversion(
        leadType === 'abandoned_checkout' ? 'checkout_started' : 'lead_created',
        eventId
    );
};
